module.exports = __webpack_public_path__ + "img/w_zd@2x.f0775947.png";